import { Record } from 'immutable';
import { ANALYTICS_SCREEN_DISCOVER } from '../analytics/Sources';
export const makeRoute = Record({
  analyticsSourceScreen: ANALYTICS_SCREEN_DISCOVER,
  path: ''
});